export default __webpack_public_path__ + "static/media/nophoto.b40055e7.jpg";